<div class="sk-page-content">
  <div class="sk-content-primary">
    <div class="sk-flex-table">
      <div class="sk-scroll-container pt-200">
        <div class="pt-100" *ngIf="loadingProductPreferences">
          <sk-text-spinner
            [message]="'sk-notifications-admin-center.preferences.' + productName + '.loader_text' | translate"
          ></sk-text-spinner>
        </div>
        <div [ngClass]="{ 'd-none': loadingProductPreferences }">
          <div class="pb-100" *ngIf="isPrimaryRecipientVisible()">
            <h3 class="pb-100">{{ 'sk-notifications-admin-center.title.' + productName + '.text' | translate }}</h3>
            <span [innerHTML]="'sk-notifications-admin-center.title.' + productName + '.note' | translate"></span>
            <div class="pt-100 col-md-5">
              <div class="pb-50">
                <sk-email-recipients-form
                  *ngIf="!loadingProductPreferences && !productPreferencesFailedToLoad"
                  [helpText]="'sk-notifications-admin-center.preferences.' + productName + '.help_text' | translate"
                  [label]="'sk-notifications-admin-center.preferences.' + productName + '.label' | translate"
                  [emailRecipients]="newProductPreferences"
                  [disabled]="savingPreferences"
                  [optional]="true"
                  [allowMultipleRecipients]="false"
                  [resetPreferencesOnCancel]="resetPreferencesOnCancel.asObservable()"
                  [updateInitialPreferencesOnSave]="updateInitialPreferencesOnSave.asObservable()"
                  (formValue)="updateProductPreferences($event)">
                </sk-email-recipients-form>
                <sk-feedback
                  *ngIf="productPreferencesFailedToLoad"
                  [dismissible]="false"
                  [subject]="'sk-notifications-admin-center.preferences.' + productName + '.fetch_error_title' | translate"
                  [message]="'sk-notifications-admin-center.preferences.' + productName + '.fetch_error_message' | translate"
                  type="danger"
                >
                </sk-feedback>
              </div>
            </div>
            <hr />
          </div>
          <div>
            <h3 class="pb-100">{{ 'sk-notifications-admin-center.secondary_title.text' | translate }}</h3>
            <span class="text-muted" [innerHTML]="'sk-notifications-admin-center.secondary_title.subText' | translate"></span>
            <div class="pt-100">
              <div class="pb-50">
                <div *ngIf="!productPreferencesFailedToLoad" class="admin-center-accordion">
                  <div class="d-flex justify-content-start mb-3">
                    <button class="btn btn-link me-3"
                      (click)="toggleAllSections()"
                      [disabled]="!hideNoEventsIcon()">
                      {{ canBeCollapsed ? ('sk-notifications-admin-center.expand_collapse_sections.collapse' | translate)
                        : ('sk-notifications-admin-center.expand_collapse_sections.expand' | translate) }}
                    </button>
                    <button class="d-none btn btn-link me-3"
                      (click)="resetDefaultCheckboxesState()"
                      [disabled]="(!hideNoEventsIcon() || !shouldEnableResetButton())">
                      {{ 'sk-notifications-admin-center.reset_to_default' | translate }}
                    </button>
                    <div class="sk-input-btn ml-auto align-items-center input-width-sm input-group">
                      <span class="text-muted pr-50">{{ 'settings.common.filterBy' | translate }}</span>
                      <div class="btn-group mr-50" ngbDropdown skStopPropagation autoClose="outside">
                        <button ngbDropdownToggle class="btn btn-basic">
                          {{ filterArea.displayName | translate }}
                          <span *ngIf="filterArea.selectedFiltersCount" class="badge rounded-pill badge-default ml-25">
                            {{ filterArea.selectedFiltersCount }}
                          </span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu">
                          <ng-container *ngFor="let filter of filterArea.filters">
                            <div class="dropdown-item">
                              <div class="form-check">
                                <input [checked]="filter.isSelected" (change)="checkFilter(filter)" type="checkbox" class="form-check-input form-check-input-sm" [id]="filter.value">
                                <label class="form-check-label" [for]="filter.value">{{ filter.displayName | translate }}</label>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <button *ngIf="showClearFiltersButton()" (click)="clearAllFilters()" type="button" class="btn btn-link sk-btn-combo px-0 ml-150">
                          <i class="material-icons md-22 md-blue">close</i><span>{{ 'settings.common.clear-filters' | translate }}</span>
                      </button>
                      <input
                        id="searchEventsInput"
                        #searchEventsInput
                        type="text"
                        class="form-control ml-150"
                        placeholder="{{ 'sk-notifications-admin-center.search.text' | translate }}"
                        aria-label="{{ 'sk-notifications-admin-center.search.text' | translate }}"
                      />
                      <i #clearSearchBtn class="material-icons md-18 sk-reset-search" title="Clear Search">close</i>
                      <button #searchEventsBtn class="btn btn-outline-secondary px-75" type="button">
                        <i class="material-icons md-18">search</i>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!loadingProductPreferences">
                    <div class="table-part" *ngIf="!hideNoEventsIcon()">
                      <div class="row justify-content-center p-3 text-muted text-center">
                          <i class="material-icons opacity-50 md-48 icon-primary">event</i>
                          <div>{{ 'sk-notifications-admin-center.search.events_not_found' | translate }}</div>
                      </div>
                    </div>
                    <sk-accordion expandable="true">
                      <ng-container *ngFor="let eventGroup of newGroupedEvents">
                        <sk-accordion-item
                          [hide]="hideAccordionEventList(getEventGroupName(eventGroup)).asObservable()"
                          [title]="getCategoryNameFromEventGroupName(eventGroup)"
                          [expanded]="expandedSections[getEventGroupName(eventGroup)]"
                          (expandedChange)="onSectionToggle(getEventGroupName(eventGroup), $event)">
                          <ng-template sk-accordion-body>
                            <div class="pb-50 col-md-5">
                              <sk-email-recipients-form
                                [helpText]="'sk-notifications-admin-center.preferences.' + productName + '.additional.help_text' | translate"
                                [label]="'sk-notifications-admin-center.preferences.' + productName + '.additional.label' | translate"
                                [emailRecipients]="getCategoryPreferences(getCategoryKeyFromEventGroupName(eventGroup))"
                                [disabled]="savingPreferences"
                                [optional]="true"
                                [allowMultipleRecipients]="true"
                                [resetPreferencesOnCancel]="resetPreferencesOnCancel.asObservable()"
                                [updateInitialPreferencesOnSave]="updateInitialPreferencesOnSave.asObservable()"
                                (formValue)="updateCategoryPreferencesContacts(getCategoryKeyFromEventGroupName(eventGroup), $event)">
                              </sk-email-recipients-form>
                            </div>
                            <table class="table table-hover sk-standard-wrap-table">
                              <thead class="thead-white thead-sm thead-border-none">
                                <tr>
                                  <th class="w-75 primary-table-header">{{ 'sk-notifications-admin-center.preferences.general.events_table.headers.notification_subject' | translate }}</th>
                                  <th class="delivery-medium-column">{{ 'sk-notifications-admin-center.preferences.general.events_table.headers.severity' | translate }}</th>
                                  <ng-container *ngFor="let medium of getEventGroupValue(eventGroup)[0].NotificationAdminCenterEventConfigurations">
                                    <th class="delivery-medium-column">
                                      <div class="d-flex align-items-center">
                                        <input [checked]="getGeneralCheckedValueForMedium(getEventGroupName(eventGroup), medium.DistributionMedium)"
                                            [disabled]="savingPreferences || getGeneralNotConfigurableByAdminValueForMedium(getEventGroupName(eventGroup), medium.DistributionMedium)"
                                          (change)="checkGeneralCheckbox(getEventGroupName(eventGroup), medium.DistributionMedium, !getGeneralCheckedValueForMedium(getEventGroupName(eventGroup), medium.DistributionMedium))"
                                          type="checkbox" class="form-check-input">
                                        <span class="ps-2">
                                          {{ getMediumDisplayName(medium.DistributionMedium) | translate }}
                                        </span>
                                      </div>
                                    </th>
                                  </ng-container>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let eventData of getEventGroupValue(eventGroup)">
                                  <tr
                                    *ngIf="showEvent(getEventGroupName(eventGroup), eventData.Key)"
                                    (click)="selectNotification(eventData, $event)"
                                    (keydown)="selectNotification(eventData, $event)"
                                  >
                                    <td class="min-w-0 px-100">
                                      <span class="font-medium text-truncate" [ngbTooltip]="eventData.Name" [openDelay]="400" [attr.aria-label]="eventData.Name">
                                        {{ eventData.Name }}
                                      </span>
                                    </td>
                                    <td>
                                      <span [ngbTooltip]="eventData.EventSeverity" [openDelay]="400" [attr.aria-label]="eventData.EventSeverity" class="d-flex ps-2">
                                        <i class="material-icons md-22 {{ eventSeverityToIconClass.get(eventData.EventSeverity) }}">{{
                                          eventSeverityToIconName.get(eventData.EventSeverity)
                                        }}</i>
                                      </span>
                                    </td>
                                    <ng-container *ngFor="let medium of eventData.NotificationAdminCenterEventConfigurations">
                                      <td class="notification-checkbox-cell">
                                        <div class="d-flex align-items-center">
                                            <input [checked]="medium.Checked" [disabled]="savingPreferences || !medium.ConfigurableByAdmin"
                                            (change)="checkSingleCheckbox(eventGroup[0], medium.EventConfigurationKey, !medium.Checked)"
                                            type="checkbox" class="form-check-input">
                                        </div>
                                      </td>
                                    </ng-container>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </ng-template>
                        </sk-accordion-item>
                      </ng-container>
                    </sk-accordion>
                  </div>
                </div>
                <div class="col-md-5">
                  <sk-feedback
                    *ngIf="productPreferencesFailedToLoad"
                    [dismissible]="false"
                    [subject]="'sk-notifications-admin-center.preferences.' + productName + '.fetch_error_title' | translate"
                    [message]="'sk-notifications-admin-center.preferences.' + productName + '.fetch_error_message' | translate"
                    type="danger"
                  >
                  </sk-feedback>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div sk-panel></div>
  </div>
</div>
<div class="sk-page-footer">
  <div class="sk-footer-content">
    <button sk-spinner-button class="btn-lg mr-100" [color]="'primary'" (click)="save()"
      [disabled]="isButtonDisabled()"
      [isSpinning]="savingPreferences">
      {{ 'sk-notifications-admin-center.save_button_text' | translate }}
    </button>
    <button (click)="cancel()" [disabled]="isButtonDisabled()" type="button" class="btn btn-lg btn-outline-secondary">
      {{ 'sk-notifications-admin-center.cancel_button_text' | translate }}
    </button>
  </div>
</div>
